export const MERCHANT_DASHBOARD_KEYS = ['DEFAULT', 'LIGHTNING'] as const;

export type MerchantDashboardKey = (typeof MERCHANT_DASHBOARD_KEYS)[number];

export const MERCHANT_DASHBOARD_KEY_OPTIONS = [
  { value: 'DEFAULT', label: 'Default' },
  { value: 'LIGHTNING', label: 'Lightning' },
] as const;

function asRecord(value: unknown): Record<string, unknown> | null {
  return value && typeof value === 'object' && !Array.isArray(value)
    ? (value as Record<string, unknown>)
    : null;
}

function readDashboardKeyValue(raw: unknown): string {
  if (typeof raw === 'string') return raw.trim();

  const root = asRecord(raw);
  if (!root) return '';

  const data = asRecord(root.data);
  const nestedData = asRecord(data?.data);

  return String(
    root.dashboardKey ??
      data?.dashboardKey ??
      nestedData?.dashboardKey ??
      '',
  ).trim();
}

/**
 * Reads `dashboardKey` from GET /merchants/{id}:
 * { success: true, data: { dashboardKey: "LIGHTNING" | "DEFAULT" } }
 * Only those two values are accepted. Anything else is Default.
 */
export function resolveMerchantDashboardKey(raw: unknown): MerchantDashboardKey {
  return readDashboardKeyValue(raw) === 'LIGHTNING' ? 'LIGHTNING' : 'DEFAULT';
}

export function isLightningMerchantDashboard(
  user: { userType?: string; dashboardKey?: string } | null | undefined,
): boolean {
  return user?.userType === 'MERCHANT' && resolveMerchantDashboardKey(user.dashboardKey) === 'LIGHTNING';
}
